<div>
  @if (!atgardMode && addProduktgruppApplicable) {
    <rask-header size="3">
      <rask-action-button
        aid="addProduktgrupp"
        (click)="addProduktgrupp()"
        [disabled]="!canEdit"
        icon="fas fa-plus">
        Lägg till produktgrupp
      </rask-action-button>
    </rask-header>
  }

  <ng-container>
    @if (vm) {
      <rask-div-list [data]="vm.utbytesberakningar">
        <rask-list-column header="Produktgrupp">
          <ng-template let-row="row" let-idx="idx">
            @if (row.new) {
              <rask-selector
                [(ngModel)]="row.produktgruppId"
                [values]="vm.valbaraProduktgrupper"
                [viewFormatter]="produktgruppViewFormatter"
                [formatter]="produktgruppFormatter"
                (change)="onProduktgruppChanged(row, idx)">
              </rask-selector>
            }
            @if (!row.new) {
              {{row.produktgrupp}}
            }
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Volym M3f" width="120px">
          <ng-template let-row="row">
            @if (!atgardMode && canEdit) {
              <rask-input-number
                [(ngModel)]="row.justeradKvantitet"
                [disabled]="atgardMode || !canEdit"
                [min]="0"
                [max]="30000"
                [placeholder]="row.volymM3fub"
                (change)="onKvantitetChanged(row)">
              </rask-input-number>
            }
            @if (atgardMode || !canEdit) {
              <rask-span>
                {{row.volymM3fub}}
              </rask-span>
            }
          </ng-template>
        </rask-list-column>
        @if (vm.isAvverkning) {
          <rask-list-custom-row>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                Summa
              </ng-template>
            </rask-list-column>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                {{vm.summaUtbytenJusterat}}
                @if (vm.hasArbetsorderJusteradeUtbyten) {
                  <rask-span
                    class="default-value">
                    ({{vm.summaUtbyten}})
                  </rask-span>
                }
              </ng-template>
            </rask-list-column>
          </rask-list-custom-row>
        }
        @if (vm.isAvverkning) {
          <rask-list-custom-row>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                Timmerandel
              </ng-template>
            </rask-list-column>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                {{vm.summaTimmerandelarJusterat}}
                @if (vm.hasArbetsorderJusteradeUtbyten) {
                  <rask-span
                    class="default-value">
                    ({{vm.summaTimmerandelar}})
                  </rask-span>
                }
              </ng-template>
            </rask-list-column>
          </rask-list-custom-row>
        }
        @if (vm.hasGrotuttagProduktionsplanerat) {
          <rask-list-custom-row>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                Grot
              </ng-template>
            </rask-list-column>
            <rask-list-column header="Produktgrupp" field="produktgrupp">
              <ng-template let-row="row">
                {{vm.direktutbyteGrot}}
              </ng-template>
            </rask-list-column>
          </rask-list-custom-row>
        }
      </rask-div-list>
    }
  </ng-container>

  @if (visaSkogligInfoApplicable) {
    <rask-toggle-panel label="Skoglig info" size="4" [defaultExpanded]="false" aid="skogliginfopanel">
      <ng-container>
        <rask-arbetsorder-tradslagsdata
          [arbetsorder]="arbetsorder"
          [atgard]="atgardMode ? atgard : null">
        </rask-arbetsorder-tradslagsdata>
      </ng-container>
    </rask-toggle-panel>
  }
</div>
